import React, { useEffect, useState, useRef } from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import countryData from "../data/countryData.json";
import "./WorldMap.css";

export default function WorldMap() {
  const [worldData, setWorldData] = useState(null);
  const mapRef = useRef(null);

  useEffect(() => {
    fetch("/world.json")
      .then((res) => res.json())
      .then((data) => setWorldData(data))
      .catch((err) => console.error("Failed to load world.json", err));
  }, []);

  const onEachCountry = (country, layer) => {
    let iso = country.properties.iso_a2?.trim();
    if (!iso || iso === "-99") iso = country.properties.iso_a2_eh?.trim();
    iso = iso?.toUpperCase();
    const data = countryData[iso] || null;
    if (!data) return;

    const popupContent = `
      <div class="popup-content">
        <img src="${data.flag}" alt="Flag of ${country.properties.name}" class="popup-flag"/>
        <p><strong>Country:</strong> <span class="popup-value">${data.name || "N/A"}</span></p>
        <p><strong>Leader:</strong> <span class="popup-value">${data.leader || "N/A"}</span></p>
        <p><strong>Population:</strong> <span class="popup-value">${data.population?.toLocaleString() || "N/A"}</span></p>
        <p><strong>Average Income:</strong> <span class="popup-value">$${data.averageIncome?.toLocaleString() || "N/A"}</span></p>
        <p><strong>Average Age:</strong> <span class="popup-value">${data.averageAge || "N/A"}</span></p>
        <p><strong>Languages:</strong> <span class="popup-value">${data.languages?.join(", ") || "N/A"}</span></p>
        <div class="fun-fact-box">
          <strong>Fun Fact:</strong> <span class="popup-value">${data.funFact || "N/A"}</span>
        </div>
      </div>
    `;

    layer.bindPopup(popupContent, {
      className: "custom-popup",
      offset: [0, -40],
    });

    layer.on({
      mouseover: (e) => {
        e.target.setStyle({ fillColor: "#3388ff", weight: 2 });

        // Hardcoded popup position for Russia
        if (iso === "RU") {
          const russiaLatLng = [60, 90]; // tweak if needed
          e.target.openPopup(russiaLatLng);
        } else {
          e.target.openPopup();
        }
      },
      mouseout: (e) => {
        e.target.setStyle({ fillColor: "#3388ff", weight: 1 });
        e.target.closePopup();
      },
    });

    layer.on("click", (e) => {
      if (!mapRef.current) return;
      const map = mapRef.current;

      let center;
      if (iso === "RU") {
        center = { lat: 60, lng: 90 }; // same as hover
      } else {
        const latlngs = layer.getLatLngs();
        const largest = Array.isArray(latlngs[0][0])
          ? latlngs.reduce((max, polygon) =>
              polygon[0].length > max[0].length ? polygon : max,
              latlngs[0]
            )
          : latlngs;
        const bounds = L.polygon(largest).getBounds();
        center = bounds.getCenter();
      }

      map.flyTo([center.lat, center.lng], 5, { duration: 1.5 });
    });
  };

  if (!worldData) return <p>Loading map...</p>;

  return (
    <MapContainer
      center={[20, 0]}
      zoom={2}
      style={{ height: "100vh", width: "100%" }}
      whenCreated={(mapInstance) => (mapRef.current = mapInstance)}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />
      <GeoJSON data={worldData.features} onEachFeature={onEachCountry} />
    </MapContainer>
  );
}
